export const CollectibleType = {
  BeerBottle: 'BEER_BOTTLE',
  BeerCrate: 'BEER_CRATE',
  GoldenBottle: 'GOLDEN_BOTTLE',
  /** Werkzeugkiste (SEG_23): bonus points. */
  Toolbox: 'TOOLBOX',
  /** Bonus-Helm (SEG_20–23). */
  ExtraLife: 'EXTRA_LIFE',
  Magnet: 'MAGNET',
  TimeBonus: 'TIME_BONUS',
} as const;

export type CollectibleType = (typeof CollectibleType)[keyof typeof CollectibleType];
